import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';
import type { Employee360Response } from './types';

export function useEmployee360(userId: string | undefined, asOf: string) {
  return useQuery({
    queryKey: ['hr', 'employee-360', userId, asOf],
    enabled: Boolean(userId),
    retry: false,
    queryFn: async () => {
      const { data } = await api.get<Employee360Response>(
        `/api/hr/people/by-user/${encodeURIComponent(userId!)}/360?asOf=${encodeURIComponent(asOf)}&limit=100`,
      );
      return data.employee360;
    },
  });
}

